import {Component, OnDestroy, OnInit} from '@angular/core';
import {Widget} from "../widget";
import {InterfaceProviderService} from "../../../basic-entity-back/services/interface-provider.service";
import {Blender} from "../../../model/segmentaciones/blender.model";
import {FilterAndData, FilterList} from "../../../api/filter-list";
import {ExactSearchFilter} from "../../../basic-entity-back/filters/search-filter";
import {map} from "rxjs/operators";

/** Segmentaciones (blenders) con el diseño validado. Mismo esquema que el de diseños analógicos. */
@Component({
    selector: 'app-segmentaciones-validadas-widget',
    templateUrl: './segmentaciones-validadas-widget.component.html',
    styleUrls: ['./segmentaciones-validadas-widget.component.scss']
})
export class SegmentacionesValidadasWidgetComponent implements Widget, OnInit, OnDestroy {
    public static minCols = 1;
    public static minRows = 2;
    public static maxRows = 2;
    public static maxCols = 1;
    public static widgetName = 'Segmentaciones validadas';
    public static widgetKey = 'segmentaciones-validadas';
    public static link = 'blenders/historico?$f-exs-0-estado="Diseño validado"';
    numeroSegmentaciones: number = 0;
    private _interval: any;
    private _intervalSeconds = 10;

    constructor(private interfaceProvider: InterfaceProviderService) {
        this.execute();
    }

    ngOnInit(): void {
        this._interval = setInterval(
            () => this.execute(),
            this._intervalSeconds * 1000);
    }

    ngOnDestroy(): void {
        clearInterval(this._interval);
    }

    private execute() {
        this.numeroSegmentaciones = 0;
        const estadoProp = this.interfaceProvider.interfaceForModel(Blender).mappingModelToApi['estado'];
        const filters: FilterList = [new FilterAndData(ExactSearchFilter, [Blender.ESTADOS_BLENDER.VALIDADO], estadoProp)];
        this.interfaceProvider.managerForModel(Blender).loader.findAndFollow(filters).pipe(map(r => {
            return r.member;
        })).subscribe(ps => {
            this.numeroSegmentaciones += ps.length;
        })
    }
}
